export default "__VITE_ASSET__wVH9k31X__"